import * as yup from 'yup';
import Regex from '../constants/regex';
import Validation from '../constants/validation-messages';

/**
 * @param {string} message
 * @this {yup.StringSchema}
 * @returns {yup.StringSchema}
 */
function names(message) {
  return this.matches(Regex.NAMES, message).max(64, Validation.MAX_CHAR_SIXTY_FOUR );
}

/**
 * Test for mobile numbers, allows spaces anywhere
 * @param {string} message
 * @param {string} regex
 * @this {yup.StringSchema}
 * @returns {yup.StringSchema}
 */
function mobile(message, regex) {
  return this.test('match-mobile', message, (value) => {
    const trimmedValue = (value ?? '').replace(/\s/g, '');
    return !value || trimmedValue.match(regex);
  });
}

yup.addMethod(yup.string, 'names', names);
yup.addMethod(yup.string, 'mobile', mobile);

export default yup;
